// src/hooks/programs/useResetProgramPdfTexts.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { resetProgramPdfTexts } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useResetProgramPdfTexts = () => {
    const queryClient = useQueryClient();

    const {
        mutate: resetPdfTextsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: (id) => resetProgramPdfTexts(id),
        onSuccess: (response, id) => {
            toast.success(response.message || "PDF texts reset to default successfully");
            queryClient.invalidateQueries({ 
                queryKey: ["program-pdf-sections", id] 
            });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to reset PDF texts");
        },
    });

    return {
        resetPdfTextsMutate,
        isPending: isPending || isLoading,
    };
};

export default useResetProgramPdfTexts;
